import { FC, type ReactElement } from "react"
import { WebGLUnavailableErrorView } from "./WebGLUnavailableErrorView"
import { GenericErrorView } from "./GenericErrorView"
import {
	BrowserAPIAvailabilityError,
	RequiredBrowserAPI,
	SmallScreenError,
	UnsupportedBrowserError,
} from "../BrowserCompatibilityGuard"
import { SmallScreenErrorView } from "./SmallScreenErrorView"

const API_AVAILABILITY_VIEWS: { [a in RequiredBrowserAPI]: () => ReactElement } = {
	webgl: () => <WebGLUnavailableErrorView />,
}

export const RootErrorView: FC<{ error: Error }> = ({ error }) => {
	if (error instanceof BrowserAPIAvailabilityError) {
		const ErrorView = API_AVAILABILITY_VIEWS[error.api] || GenericErrorView
		return <ErrorView />
	}

	if (error instanceof SmallScreenError) {
		return <SmallScreenErrorView />
	}

	if (error instanceof UnsupportedBrowserError) {
		return <GenericErrorView />
	}

	if (error.message.includes("WebGL")) {
		return <WebGLUnavailableErrorView />
	}

	return <GenericErrorView />
}
